
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-flows",
      function () {
        return require("private-next-pages/whatsapp-flows.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-flows"])
      });
    }
  